import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { SuccessError } from '../../../../../../shared/general/components/success-error/success-error';

@Component({
  selector: 'app-listing-form-success',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    SuccessError
  ],
  templateUrl: './listing-form-success.html',
  styleUrl: './listing-form-success.scss',
})
export class ListingFormSuccess {


  downloadForm() {
    console.log('downloadForm');
  }
}
